import { Sized, Variable } from '@optimus-web/common';
import { MewsLogoVariant } from '@optimus-web/local-tokens';
import { MewsLogoPath, MewsLogoSvg, MewsLogoWrapper } from './style';

interface MewsLogoProps extends Sized, Variable<MewsLogoVariant> {
    protectiveArea?: boolean;
    type?: 'wordmark' | 'logomark';
}

const MewsLogo = ({
    type = 'wordmark',
    variant = 'default',
    size = 'medium',
    protectiveArea = true,
    ...other
}: MewsLogoProps) => (
    <MewsLogoWrapper protectiveArea={protectiveArea} size={size} {...other}>
        {type === 'wordmark' ? (
            <MewsLogoSvg
                fill="none"
                width="191"
                height="24"
                viewBox="0 0 191 24"
                preserveAspectRatio="xMidYMid meet"
                size={size}
            >
                <MewsLogoPath
                    variant={variant}
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M180.514 9.85599C184.008 10.029 189.288 10.2904 189.953 14.7011C190.285 16.9061 190.074 19.6148 188.274 21.1811C186.442 22.774 184.001 23.2834 181.675 23.6179C179.036 23.9981 176.352 24 173.693 24H173.606C166.637 24 160.29 23.0306 156.158 22.2056L156.669 17.8109C162.934 18.7822 168.382 19.4266 174.55 19.4266C177.088 19.4266 179.7 19.3562 182.175 18.8411C184.068 18.4457 184.984 17.4497 184.847 16.0754C184.695 14.5357 183.138 14.2696 181.8 14.2088C180.262 14.1403 165.753 13.726 165.753 13.726L165.526 13.7157C162.52 13.5805 157.918 13.3736 156.595 10.0763C155.806 8.10898 155.941 5.22541 157.243 3.51845C158.777 1.50927 161.904 0.853477 164.759 0.479012C167.177 0.161571 169.836 0 172.663 0C178.706 0 184.366 0.899097 188.457 1.65943L188.451 1.68985L187.862 6.04087C182.437 5.04863 177.301 4.43656 171.716 4.43656C169.177 4.43656 166.616 4.48218 164.054 5.02392C162.771 5.29574 161.36 6.02186 161.52 7.58625C161.672 9.08031 163.229 9.33882 164.567 9.39775C166.088 9.46428 180.511 9.85585 180.511 9.85585L180.514 9.85599ZM6.12641 0.161606L20.5519 18.0903L34.9754 0.161606H41.1018V23.8499H35.6845V7.42852L23.6788 22.352C21.9756 24.4695 19.1224 24.4619 17.425 22.352L5.41739 7.42852V23.848H0V0.161606H6.12641ZM86.4293 0.161606H54.9229V23.848H86.6935L87.4899 19.0578H60.3402V14.4008H85.3534V9.61068H60.3402V4.95172H86.4293V0.161606ZM148.594 0.161585L138.712 23.8422H132.962L122.629 5.15889L112.296 23.8422H106.546L96.6634 0.161585H102.256L109.821 18.288L118.736 2.31714C119.536 0.923821 121.021 0.064642 122.629 0.064642C124.235 0.064642 125.72 0.923821 126.522 2.31714L135.437 18.288L143 0.161585H148.594Z"
                />
            </MewsLogoSvg>
        ) : (
            <MewsLogoSvg
                width="42"
                height="24"
                viewBox="0 0 42 24"
                preserveAspectRatio="xMidYMid meet"
                size={size}
                protectiveArea={protectiveArea}
                {...other}
            >
                <MewsLogoPath
                    variant={variant}
                    d="M20.9958 18.0979L6.4342 0H0.25V23.9098H5.7185V7.33547L17.8394 22.3997C19.5528 24.5296 22.4329 24.5373 24.1521 22.3997L36.2711 7.33547V23.9117H41.7396V0H35.5554L20.9958 18.0979Z"
                    fill="black"
                />
            </MewsLogoSvg>
        )}
    </MewsLogoWrapper>
);

export default MewsLogo;
